import { Box, Button, FlexLayout, H1, H3 } from '@deity-io/portal-ui';
import React from 'react';

class ErrorBoundary extends React.Component<{}, { error: any; errorInfo: any }> {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.warn('ErrorBoundary got a Error', error);
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <FlexLayout alignItems="center" flexDirection="column">
          <Box marginBottom="24px">
            <H1>:-(</H1>
            <H3>Sorry, something went wrong. Please refresh the page. </H3>
            <>{process.env.NODE_ENV !== 'production' ? `${this.state.error}` : ''}</>
          </Box>
          <Button variant="contained" onClick={() => location.reload()}>
            Refresh the page
          </Button>
        </FlexLayout>
      );
    }

    // Normally, just render children
    return <>{this.props.children}</>;
  }
}

export default ErrorBoundary;
